export const formatCurrency = (amount: string | number): string | number => {
	if (!amount) {
		return 0;
	}
	const formatted = Number(amount)
		.toFixed(2)
		.replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,');

	// To remove trailing zeroes
	let i = formatted.length;
	while (formatted[i - 1] === '0') {
		i -= 1;
	}
	if (formatted[i - 1] === '.') i -= 1;
	return formatted.slice(0, i);
};
